import React from "react";
import { Box, Stack } from "@mui/material";
import Styles from "./Footer.module.css";

const Footer: React.FC = () => {
  return (
    <Box className={Styles.footer_container}>
      <Stack className={Styles.footer_container_top}>
        <Stack className={Styles.footer_container_socialmedia}>
          <Stack className={Styles.footer_container_companylogo}>
            <img
              src="https://firebasestorage.googleapis.com/v0/b/onestolabs-09.firebasestorage.app/o/footer%2Fonestolabs_logo_footer.png?alt=media&token=8e53f460-c30c-4953-af76-42f7d63be9be"
              alt="OnestoLogo"
            />
          </Stack>
        </Stack>
      </Stack>

      <Stack className={Styles.footer_container_bottom}>
        <Stack className={Styles.footer_container_copyright}>
          © 2026 Onestolabs. All rights reserved.
        </Stack>
      </Stack>
    </Box>
  );
};

export default Footer;